(function (A) {
    if (typeof (A.jQuery) == "undefined") { 
        return false 
    }
    
    var myTool = "jtool",
        $ = A.jQuery,
        t = function (a, b) { return $(a, b) },
        DCM = A.document,
        DEM = DCM.documentElement,
        DBD = DCM.body;
    
    // 扩展方法定义
    t.extend = function () {
        for (var ky in arguments[0]) {
            this[ky] = arguments[0][ky];
        }
    };
    
    var cHref = A.location,
        pHost = cHref.protocol + "//" + cHref.host, // 协议://域名:端口号
        ERRORS = {
            'e1': "没有权限操作外连iframe！",
            'e2': "无法外链请求！",
            'e3': "参数输入错误"
        },
        
        // 常用正则表达式集合
        http = new RegExp("^https?://", "gi"),
        hTag = new RegExp("<(\\w+)\\s?", "gi"),
        xmlTag = new RegExp("<.+?>", "gi"),
        wTag = new RegExp("(^[\\s\\r\\n\\0\\t\\x0B]*)|([\\s\\r\\n\\0\\t\\x0B]*$)", "g"),
        regTag = new RegExp("([\\$\\(\\)\\*\\+\\.\\[\\?\\\\\\^\\{\\|])", "gi"),
        
        // 以下为内部使用方法
        
        /**
         * 系统初始化
         */
        init = function(){
            //修正部分浏览器XPath问题
            if(document.implementation.hasFeature("XPath","3.0")){
                XMLDocument.prototype.selectNodes=function(cXPathString,xNode){
                    if(!xNode){xNode=this;}
                    var oNSResolver=this.createNSResolver(this.documentElement);
                    var aItems=this.evaluate(cXPathString, xNode, oNSResolver,XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
                    var aResult=[];
                    for(var i=0;i< aItems.snapshotLength;i++){
                        aResult[i]=aItems.snapshotItem(i);
                    }
                    return aResult;
                }
                Element.prototype.selectNodes=function(cXPathString){
                    if(this.ownerDocument.selectNodes){
                        return this.ownerDocument.selectNodes(cXPathString,this);
                    }else{throw "For XML Elements Only";}
                }
            }
            
            // 修正IE没有开启console
            if(typeof(A.console)=='undefined'){
                // 定义log函数
                var log=function(){
                    var tid='console_log_'+t.startTime;
                    var style='position:absolute;z-index:999;top:0;right:0;width:300px;height:30px;text-align:left;font-size:12px;overflow-y:auto;background:#000;color:#f00';
                    if(!ID(tid)){
                        $('body').append('<div id="'+tid+'" style="'+style+'"></div>');
                    }
                    var strs=[];
                    for(var i=0;i < arguments.length; i++){
                        strs.push(arguments[i]);
                    }
                    ID(tid).innerHTML=strs.join(' ')+"<br/>"+ID(tid).innerHTML;
                };
                var attrs=[
                        "debug", "error", "info", "warn", "dir", 
                        "dirxml", "table", "trace", "group", "groupCollapsed", 
                        "groupEnd", "clear", "count", "countReset", "assert", 
                        "profile", "profileEnd", "time", "timeLog", "timeEnd", 
                        "timeStamp", "context"
                    ];
                A.console={};
                A.console.log=log;
                for (var i = 0; i < attrs.length; i++) {
                    A.console[attrs[i]]=function(){return false}
                }
            }
        },
        
        /**
         * 增强型NULL值判断
         */
        isNull = function (ep) {
            if (typeof (ep) != "undefined" && !ep && ep != 0) {
                return true;
            } else {
                return false
            }
        },
        
        /**
         * 此判断依据是拥有序列的数字索引即视为数组对象
         */
        isArray = function (arr) {
            if (typeof (arr) != "object") { return false };
            var idx = 0;
            for (var k in arr) {
                if (k != idx) { return false; }
                idx++;
            }
            return true;
        },
        
        /**
         * 获取路径信息
         */
        pathInfo = function (s) {
            var rObj = {};
            s = s.replace(/\?.*?$/gi, "");
            rObj["dir"] = s.replace(/[^\/\\]+$/gi, "");
            rObj["base"] = s.match(/[^\/\\]+$/gi) ? s.match(/[^\/]+$/gi)[0].replace(/\.\w+$/gi, "") : "";
            rObj["ext"] = s.match(/\.\w+$/gi) ? s.match(/\.\w+$/gi)[0].toLowerCase().replace(/\./gi, "") : "";
            return rObj;
        },
        
        /**
         * 获取事件对象
         */
        getEvent = function () {
            if (DCM.all) { return A.event; }
            var func = getEvent.caller;
            while (func != null) {
                var arg0 = func.arguments[0];
                if (arg0) {
                    if ((arg0.constructor == Event || arg0.constructor == MouseEvent) || (typeof (arg0) == "object" && arg0.preventDefault && arg0.stopPropagation)) {
                        return arg0;
                    }
                }
                func = func.caller;
            }
            return null;
        },
        
        
        /**
         * 判断文件是否已经加载
         */
        isLoadFile = function (src, tp) {
            var type = getFileType(src, tp), i;
            if (type == "js" || type == "vbs") {
                var scripts = DCM.getElementsByTagName("script");
                for (i = 0; i < scripts.length; i++) {
                    if (scripts[i].src && scripts[i].src.indexOf(src) != -1) {
                        if (scripts[i].readyState == "loaded" || scripts[i].readyState == "complete") {
                            return scripts[i];
                        }
                    }
                }
            } else if (type == "css") {
                var links = DCM.getElementsByTagName("link");
                for (i = 0; i < links.length; i++) {
                    if (links[i].href && links[i].href.indexOf(src) != -1) {
                        if (links[i].readyState == "loaded" || links[i].readyState == "complete" || links[i].readyState == "interactive") {
                            return links[i];
                        }
                    }
                }
            }
            return false;
        },
        
        /**
         * 获取文件类型
         */
        getFileType = function (src, tp) {
            if (typeof (tp) != "undefined") {
                return tp.toLowerCase();
            }
            if(src.indexOf('?')!=-1){
                src=src.substring(0, src.indexOf('?'));
            }
            var type = "", lastIndex = src.lastIndexOf(".");
            if (lastIndex != -1) {
                type = src.substr(lastIndex + 1);
            }
            return type;
        },
        
        // 常用函数
        /**
         *  根据ID选择对象
         */
        ID = function (a, cDCM) {
            if (typeof (a) == "object") { return a; };
            var cObj = (cDCM ? cDCM : DCM).getElementById(a);
            return isNull(cObj) ? false : cObj;
        },
        
         /**
         * 获取URL参数
         * @param {string} fd 字段名称
         * @param {mixed} defaultValue 默认值
         * @param {string} target 目标字符串，默认获取当前URL
         */
        query = function (fd, defaultValue, target) {
            var fullUrl = ( typeof(target) == "object" ? target.location.href : 
                            (typeof (target) == "string" ? target : cHref.href)
                         ),
                vtp = "s",subUrl, urlArr = [], tparr = [], param={};
            
            if(typeof(fd)=='string' && fd.indexOf('/')!=-1){
                vtp=fd.substr(fd.indexOf('/')+1);
                fd=fd.substr(0, fd.indexOf('/'));
            }

            if (fullUrl.indexOf('?') != -1) {
                subUrl = fullUrl.substr(fullUrl.indexOf('?') + 1, fullUrl.length);
                urlArr = subUrl.split('&');
                for (var ky in urlArr) {
                    try {
                        if (typeof (urlArr[ky]) != "string") { continue };
                        tparr = urlArr[ky].split('=');
                        var key=trim(tparr[0]);
                        var val=typeof(tparr[1])!='undefined' ? trim(tparr[1]) : '';
                        param[key] = val;
                    } catch (e) { }
                }
            }
            
            if(fd === undefined){
                return param;
            }
            
            var value=typeof(param[fd])!='undefined' ? param[fd] : defaultValue ;
            if(typeof(value)=='string' && (vtp=='d'||vtp=='f')){
                value=vtp=='d' ? parseInt(value) : parseFloat(value);
                return isNaN(value) ? defaultValue : value;
            }
            return value;
        },
        
        /**
         * 获取传递给当前脚本的参数
         * @param {string} key 字段名称
         * @param {mixed} defaultValue 默认值
         */
        getJsParam = function(key, defaultValue){
            var header, scripts, src;
            header=DCM.getElementsByTagName("head")[0];
            scripts = header.getElementsByTagName("script");
            src = scripts[scripts.length-1].src;
            return query(key, defaultValue, src);
        },
        
        /*
            参数形式:gDomain([cURL][,gtp])
            获取:"协议://域名:端口号"组成的字符串，gtp为test判断是否同域
        */
        gDomain = function () {
            var oArr = ["protocol", "host", "port", "full", "test"],
                cURL = trim(arguments[0]).match(http) ? trim(arguments[0]) : pHost,
                gtp = findVl(arguments[0], oArr) ? arguments[0] : (findVl(arguments[1], oArr) ? arguments[1] : "full"),
                phREG = new RegExp("^http://[^/]+(:\d+)?", "i"),
                cDomain = cURL.match(phREG)[0];
            switch (gtp) {
                case "protocol":
                    return (cDomain.match(/^[^:\/]+/i)[0]);
                case "host":
                    return (cDomain.match(/\/[^\/:]+/i)[0].replace(/\//, ""));
                case "port":
                    return (cDomain.match(/:[^\/:]+/i)[0].replace(/:/, ""));
                case "full":
                    return cDomain;
                case "test":
                    return (arguments[0].toLowerCase() == "about:blank" || cDomain == pHost);
            }
        },
        
        /**
         * 获取时间戳
         */
        timeNum = function () {
            return (new Date()).getTime();
        },
        
        /**
         * 错误处理
         */
        error = function (tp) {
            if(typeof(tp)=='function'){
                A.onerror = function () {
                    return !tp.call(A, {
                        message: arguments[0],
                        file: arguments[1],
                        line: arguments[2]
                    });
                };
            }else{
                A.onerror = function () { return !!tp; };
            }
        },
        
        /**
         * 删除增字符串左右空白字符
         */
        trim = function (str) {
            if (typeof (str) == "undefined" || (!str && str !== 0)) { return ''; };
            if (typeof (str) == "number" || typeof (str) == "string") {
                return str.toString().replace(wTag, "").replace(/　/gi, "");
            } else if (typeof (str) == "object") {
                return str;
            } else {
                return '';
            }
        },
        
        /**
         * 删除增字符串所有空白字符
         */
        inTrim = function (str) {
            str = trim(str);
            return str.replace(/[\s\r\n\0\t\x0B]*/gi, "");
        },
        
        /**
         * 去除字符串的所有标签
         */
        tagTrim = function (str) {
            str = trim(str);
            return str.replace(/>[\s\r\n\0\t\x0B]*</gi, "><"); /*>*/
        },
        
        /**
         * 转换正则表达式中的特殊字符
         */
        REG = function (str) {
            return str.replace(regTag, "\\$1");
        },
        
        /**
         * 查找值
         * 适用于字符串，对象，数组
         */
        findVl = function (vl, obj, tp) {
            var reky = -1, tpArr = [];
            if (typeof (obj) == "string") {
                tpArr = obj.match(new RegExp("(" + REG(vl) + ")", "g"));
                if (!tpArr) { return reky; }
            } else {
                for (var k = 0; k < obj.length; k++) {
                    tpArr.push(obj[k]);
                }
            }
            for (var ck = 0; ck < tpArr.length; ck++) {
                if (tpArr[ck] === vl) { reky = ck; }/*注：此处必须是恒等于*/
            }
            switch (tp) {
                case "pre":
                    reky = (reky - 1 >= 0) ? (reky - 1) : (tpArr.length - 1);
                    break;
                case "next":
                    reky = (reky + 1 >= tpArr.length) ? 0 : (reky + 1);
                    break;
                case "key": /*返回找到的键值,没有找到，返回-1*/
                    return (typeof (obj) == "string" ? (obj.indexOf(tpArr[reky])) : reky);
                default: /*判断是否存在*/
                    return (reky == -1 ? false : true);
            }
            return (typeof (obj) == "string" ? (obj.indexOf(tpArr[reky])) : tpArr[reky]);
        },
        
        /**
         * vl为数组，每个值依次在obj对象中查找，找到则返回值,没有返回默认值dft
         */
        setUVL = function (vl, obj, dft) {
            var first = function (cObj) {
                    for (var ci = 0; ci < cObj.length; ci++) {
                        return cObj[ci]
                    } 
                },
                dft = dft ? dft : first(obj);
            if (!isArray(vl)) {
                if (findVl(vl, obj)) {
                    return vl;
                }
            } else {
                for (var i = 0; i < vl.length; i++) {
                    if (findVl(vl[i], obj)) {
                        return vl[i];
                    }
                }
            }
            return dft;
        },
        
        /*
            功能：此函数可以设置或获取对象的值
            参数：val(tObj[,vl]),tObj可以为ID值或DOM对象，或DOM对象和ID值对象虚拟数组
            说明：当有vl参数，设置对象序列的值，返回有效设置的个数；
                当无vl参数，当tObj为数组时，返回的是获取值的数组，tObj为ID值或DOM对象，返回单个值
        */
        val = function (tObj, vl) {
            var tObj = ID(tObj), ObArr = [], obj, tgName, 
                inTagArr = ["input", "textarea", "select"], 
                reArr = [], tNum = 0;
            if (!tObj) { return false; };
            if (!isArray(tObj)) {
                ObArr.push(tObj) 
            } else {
                for (var i = 0; i < tObj.length; i++) {
                    ObArr.push(tObj[i]); 
                } 
            };
            for (var ti = 0; ti < ObArr.length; ti++) {
                obj = ID(ObArr[ti]);
                if (!obj) { continue };
                tgName = obj.tagName.toLowerCase();
                if (findVl(tgName, inTagArr)) {
                    if (typeof (vl) != "undefined") { obj.value = vl; } else { reArr.push(obj.value); }
                    tNum++;
                } else {
                    if (tgName == "iframe") {
                        try {
                            if (typeof (vl) != "undefined") {
                                t(obj.contentWindow.document.body).text(vl);
                            } else {
                                reArr.push(t(obj.contentWindow.document.body).text());
                            }
                            tNum++;
                        } catch (e) {/*return error('e1');*/ }
                    } else {
                        if (typeof (vl) != "undefined") { obj.innerHTML = vl; } else { reArr.push(obj.innerHTML); }
                        tNum++;
                    }
                }
            }
            return (typeof (vl) != "undefined" ? tNum : (isArray(tObj) ? reArr : reArr[0]));
        },
        
        /**
         * 创建DOM对象
         * 参数形式: para:{'tag':'input','attr':{'type':'text','value':''}},tgt:目标
         */
        cElem = function (para, tgt) {
            var tObj = tgt || DCM.body, cObj, ky, Vl, Tag = para['tag'].toLowerCase(),
                eName = para['attr']['name'] || para['attr']['id'] || "tElem" + t.startTime;
            try { /*防止IE下iframe的name属性无效*/
                cObj = (Tag == "iframe" && $.browser.msie ? DCM.createElement("<" + Tag + " name=\"" + eName + "\">") : DCM.createElement(Tag));
            } catch (e) {
                cObj = DCM.createElement(Tag);
            }
            if (Tag == "iframe") {
                if (typeof (para['attr']['value']) != "undefined") {
                    Vl = para['attr']['value'];
                    delete para['attr']['value'];
                }
                if (typeof (para['attr']['src']) == "undefined") {
                    para['attr']['src'] = "about:blank";
                }
                t(cObj).attr(para['attr']);

                if (typeof (para['attr']['inStyle']) == "undefined") {
                    para['attr']['inStyle'] = "*{margin:2px;padding:0px;font-size:12px;}";
                }
                para['attr']['inStyle'] += "body{cursor:text}";

                if (para['attr']['src'] && typeof (Vl) != "undefined" && gDomain(para['attr']['src'], "test")) {
                    var iHtml = '<html><head><style type="text/css">' + para['attr']['inStyle'] + '</style></head><body>' + Vl + '</body></html>';
                    if (A.jQuery.browser.msie) {
                        t(cObj).bind("readystatechange", function () {
                            if (findVl(cObj.readyState, ["complete", "loaded"])) {
                                cObj.contentWindow.document.write(iHtml);
                                if (para['attr']['editable']) {
                                    cObj.contentWindow.document.body.contentEditable = true;
                                }
                                t(cObj).bind("readystatechange", arguments.callee);
                            }
                        });
                    } else {
                        t(cObj).bind("load", function () {
                            cObj.contentWindow.document.open();
                            cObj.contentWindow.document.write(iHtml);
                            cObj.contentWindow.document.close();
                            if (para['attr']['editable']) {
                                cObj.contentWindow.document.designMode = "on";
                            }
                            t(cObj).bind("load", arguments.callee);
                        });
                    }
                }
            } else {
                t(cObj).attr(para['attr']);
            }
            tObj.appendChild(cObj);
            return cObj;
        },
        
        /**
         * flash版本判断
         */
        swfVersion = function () {
            var f = "-", n = navigator;
            if (n.plugins && n.plugins.length) {
                for (var ii = 0; ii < n.plugins.length; ii++) {
                    if (n.plugins[ii].name.indexOf('Shockwave Flash') != -1) {
                        f = n.plugins[ii].description.split('Shockwave Flash ')[1];
                        break;
                    }
                }
            } else if (window.ActiveXObject) {
                for (var ii = 12; ii >= 2; ii--) {
                    try {
                        var fl = eval("new ActiveXObject('ShockwaveFlash.ShockwaveFlash." + ii + "');");
                        if (fl) {
                            f = ii + '.0';
                            break;
                        }
                    } catch (e) { }
                }
            }
            return f;
        },
        
        /**
         * 为原RUL添加参数,返回添加后的URL
         */
        aPara = function (url, para) {
            if (!trim(para)) { return url; };
            var url = url + (findVl("?", url) != -1 ? '&' : '?');
            return url + t.toURL(para);
        },
        
        /**
         * 加密
         */
        enCode = function (cnt, ctp) {
            switch (ctp) {
                case "xu": /*十六进制编码*/
                    cnt = escape(cnt).replace(/%u/gi, "\\u");
                    break;
                default: /*URL编码*/
                    cnt = encodeURIComponent(cnt);
                    break;
            }
            return cnt;
        },
        
        /**
         * 解密
         */
        deCode = function (cnt, ctp) {
            switch (ctp) {
                case "xu": /*十六进制解码*/
                    var reg = /\\u(\w{4})/g;
                    cnt = cnt.replace(reg,
                        function ($0, $1, $2) {
                            return unescape("%u" + $1);
                        }
                    );
                    break;
                default: /*URL解码*/
                    cnt = decodeURIComponent(cnt);
                    break;
            }
            return cnt;
        },
        
        /**
         * 获取对象键组成的数组
         */
        objKeys = function (obj) {
            var rArr = [];
            if (typeof (obj) != "object") { return rArr; }
            for (var ky in obj) { rArr.push(ky); }
            return rArr;
        },
        
        /**
         * 获取对象值组成的数组
         */
        objValues = function (obj) {
            var rArr = [];
            if (typeof (obj) != "object") { return rArr; }
            for (var ky in obj) { rArr.push(obj[ky]); }
            return rArr;
        },
        
        /**
         * 交换对象的键值
         */
        objFlip = function (obj) {
            var rObj = {};
            if (typeof (obj) != "object") { return rObj; }
            for (var ky in obj) {
                if (trim(obj[ky]).match(/^\w+$/gi)) {
                    rObj[obj[ky]] = ky;
                }
            }
            return rObj;
        },
        
        /**
         * 合并对象，后面的对象覆盖有相同的键名则覆盖前一个对象的键值
         */
        objMerge = function () {
            /*参数:obj1,obj2,obj3...*/
            var rObj = {};
            if (!arguments.length) { return rObj; }
            for (var i = 0; i < arguments.length; i++) {
                if (typeof (arguments[i]) != "object") { continue; }
                for (var ky in arguments[i]) {
                    rObj[ky] = arguments[i][ky];
                }
            }
            return rObj;
        },
        
        /**
         * 对数组对象中的每个元素执行回调函数
         */
        objEach = function (obj, callBack) {
            /*参数:obj,callBack*/
            if (typeof (obj) != "object") { return false; }
            var fn = (typeof (callBack) != "function" ? function () { } : callBack);
            for (var ky in obj) { (fn)(obj[ky], ky); }
            return true;
        },
        
        /**
         * 字符串截取
         */
        mbCutStr = function(str, maxlen, dot){
            var len = 0;
            var ret = '';
            var dot = !dot ? '...' : '';
            maxlen = maxlen - dot.length;
            for(var i = 0; i < str.length; i++) {
                len += str.charCodeAt(i) < 0 || str.charCodeAt(i) > 255 ? 3 : 1;
                if(len > maxlen) {
                    ret += dot;
                    break;
                }
                ret += str.substr(i, 1);
            }
            return ret;
        },
        
        /**
         * 跨域请求（通过构建iframe请求）
         * 
         * 参数形式1: t.post(url[,obj][,fn][,method]);
         *  obj参数:传递的字符串、数组、常规对象，
         *     当为字符串时是form标签或有子节点的标签的ID值，
         *     为数组时，是ID序列，
         *     为对象时，对象的每个键名和键值即是提交的参数名和值;
         * fn参数:回调函数或可执行的字符串
         * 说明：默认使用post请求
         */
        request = function () {
            // 参数处理
            var url = arguments[0] || "",
                pObj = (findVl(typeof (arguments[1]), ['object', 'string']) ? arguments[1] : {}),
                fn = (
                        typeof (arguments[1]) == "function" ? arguments[1] : 
                        (typeof (arguments[2]) == "function" ? arguments[2] : false)
                    ),
                mtd = (
                        typeof (arguments[2]) == "string" ? arguments[2] :
                            (
                                arguments[3] ? 
                                (findVl(arguments[3].toLowerCase(), ["post", "get"]) ? arguments[3] : "post") : 
                                "post"
                            )
                    ),
                tIframe = "doFrame" + t.startTime, 
                iObj = ID(tIframe), 
                startTime = t.timeNum(), 
                fObj, fDiv;
            
            if (!url||url=="") { return false };
            
            // 创建form实体表单
            if (!iObj || iObj.tagName.toLowerCase() != "iframe") {
                iObj = cElem({
                    "tag": "iframe", 
                    "attr": {
                            'id': tIframe, 'name': tIframe, 
                            'frameBorder': '0', 
                            'src': 'about:blank', 
                            'style': 'display:none;visibility:hidden;width:0px;height:0px' 
                    } 
                });
            }
            
            // 处理返回结果
            var doAfter=function(){
                    if (typeof(fn)=='function') {
                        if (gDomain(url, "test")) {
                            // 同一个域则返回处理后内容
                            var result=val(iObj), json;
                            try {
                                fn.call(this, $.parseJSON(result));
                            } catch (e) {
                                fn.call(this, result);
                            }
                            
                        } else {
                            // 不同域则返回处理耗时
                            fn.call(this, t.timeNum() - startTime);
                        }
                    }
                }
            
            // 绑定事件
            var bindFn = function (fDiv) {
                // 通过轮询检测加载事件
                var timer = setInterval(function () {
                    var iframeDoc = iObj.contentDocument || iObj.contentWindow.document;
                    if (
                        iframeDoc.readyState == 'complete' || 
                        iframeDoc.readyState == 'loaded' || 
                        iframeDoc.readyState == 'interactive'
                    ) {
                        doAfter.call(iframeDoc);
                        if (fDiv) { DCM.body.removeChild(fDiv); }
                        clearInterval(timer);
                        return;
                    }
                }, 200);
            };
    
            if (typeof (pObj) == "object") {
                // 当pObj参数为参考对象或数组，则根据常规对象键值或数组ID值建立提交表单
                fDiv = cElem({ "tag": "div", "attr": { 'style': 'visibility:hidden;display:none;height:0px;width:0px;' } });
                fObj = cElem({ "tag": "form", "attr": { 'style': 'display:inline;' } }, fDiv);
                if (isArray(pObj)) {
                    for (var fi = 0; fi < pObj.length; fi++) {
                        fObj.appendChild(cElem({ "tag": "textarea", "attr": { 'id': pObj[fi], 'name': pObj[fi], 'value': val(pObj[fi]) } }));
                    }
                } else {
                    for (var fi in pObj) {
                        if(isArray(pObj[fi])){
                            for (var i = 0; i < pObj[fi].length; i++) {
                                fObj.appendChild(cElem({ "tag": "textarea", "attr": { 'id': fi+"_"+i, 'name': fi+"[]", 'value': pObj[fi][i] } }));
                            }
                        }else{
                            fObj.appendChild(cElem({ "tag": "textarea", "attr": { 'id': fi, 'name': fi, 'value': pObj[fi] } }));
                        }
                    }
                }
            } else {
                // 当pObj参数为字符串，则提交当前ID值pObj内部的控件值
                fObj = ID(pObj);
                if (!fObj) { return false; }
                if (
                    fObj.tagName.toLowerCase() != "form" && 
                    fObj.parentNode.tagName.toLowerCase() != "form"
                ) {
                    var inNode = fObj.cloneNode(true), tpSpan;
                    tpSpan = cElem({ "tag": "span", "attr": { 'style': 'display:inline;' } }, fObj);
                    fObj.parentNode.replaceChild(tpSpan, fObj);
                    fObj = cElem({ "tag": "form", "attr": { 'style': 'display:inline;' } }, tpSpan);
                    fObj.appendChild(inNode);
                } else if (fObj.parentNode.tagName.toLowerCase() == "form") {
                    fObj = fObj.parentNode;
                }
            }
            
            fObj.setAttribute("target", tIframe);
            fObj.setAttribute("action", url);
            fObj.setAttribute("method", mtd);
            bindFn(fDiv);
            fObj.submit();
        },
        
        /**
         * 格式化文件的大小
         * 
         * @param {Number} size 
         * @param {Number} bits 
         */
        sizeformat=function(size, bits){
            var unit=['B','KB','MB','GB','TB','PB'],
                bits=typeof(bits)=="undefined"? 2 : bits,
                i=Math.floor(Math.log(size) / Math.log(1024)),
                bits=Math.pow(10,bits);
            return Math.round((size / Math.pow(1024, i)) * bits) / bits + unit[i];
        };

    // 属性定义
    t.startTime = timeNum();
    t.swfVersion = swfVersion();
    
    // 内部函数扩展
    t.extend({
        'ID': ID,
        'query': query,
        'getJsParam': getJsParam,
        'gDomain': gDomain,
        'timeNum': timeNum,
        'error': error,
        'trim': trim,
        'inTrim': inTrim,
        'tagTrim': tagTrim,
        'REG': REG,
        'findVl': findVl,
        'setUVL': setUVL,
        'val': val,
        'cElem': cElem,
        'aPara': aPara,
        'enCode': enCode,
        'deCode': deCode,
        'objKeys': objKeys,
        'objValues': objValues,
        'objFlip': objFlip,
        'objMerge': objMerge,
        'objEach': objEach,
        'mbCutStr': mbCutStr,
        'request': request,
        'sizeformat': sizeformat
    });
    
    // 外部扩展
    t.extend({
        /**
         * POST请求
         */
        post: request,
        
        /**
         * GET请求
         */
        get: function () {
            request(arguments[0], arguments[1], arguments[2], "get");
        },
        
        /**
         * 文件加载
         * @param {string} src 文件路径
         * @param {function|string} fn 回调函数，为字符串则为文件类型参数
         * @param {string} tp 文件类型，如: js/css/vbs
         */
        loadFile: function (src, fn, tp) {
            if(typeof(fn)=='string'){
                tp=fn;
                fn=undefined;
            }
            var obj=isLoadFile(src, tp);
            if (obj) {
                if (typeof (fn) == "function") { fn(obj) }
            } else {
                var type = getFileType(src, tp);
                var head =DCM.getElementsByTagName("head")[0];
                if (type == "js" || type == "vbs") {
                    obj = DCM.createElement("script");
                    obj.src = src;
                    obj.async = "async";
                    if (type == "js") {
                        obj.type = "text/javascript";
                    } else {
                        obj.type = "text/vbscript";
                    }
                } else if (type == "css") {
                    obj = DCM.createElement("link");
                    obj.rel = "stylesheet";
                    obj.type = "text/css";
                    obj.href = src;
                } else {
                    return false;
                }
                
                obj.onload=obj.onreadystatechange=function(_, isAbort ){
                    if ( isAbort || !obj.readyState || /loaded|complete/.test( obj.readyState ) ) {
                        obj.onload = obj.onreadystatechange = null;
                        if ( !isAbort ) {
							if (typeof (fn) == "function") { fn(obj) }
						}
                    }
                }
                
                obj.onerror = function () {
                    head.removeChild(obj);
                };
                head.appendChild(obj);
            }
            return obj;
        },
        
        /*cookie操作系列函数*/
        cookie: function (ckNa, ckVl, ops) {
            if (!arguments.length) { return false };
            if (arguments.length == 1) {
                return t.getCookie(ckNa);
            } else if (ckVl != null && ckVl != "null" && ckVl != "") {
                return t.setCookie(ckNa, ckVl, ops);
            } else {
                return t.delCookie(ckNa);
            }
        },
        setCookie: function (ckNa, ckVl, ops) {
            try {
                var ops = ops || {};
                if (ckVl === null) {
                    ckVl = '';
                    ops.expires = -1;
                }
                var expires = '';
                if (ops.expires && (typeof ops.expires == 'number' || ops.expires.toUTCString)) {
                    var date;
                    if (typeof ops.expires == 'number') {
                        date = new Date();
                        date.setTime(date.getTime() + (ops.expires * 24 * 60 * 60 * 1000));
                    } else {
                        date = ops.expires;
                    }
                    expires = '; expires=' + date.toUTCString();
                }
                var path = ops.path ? '; path=' + ops.path : '; path=/',
                    domain = ops.domain ? '; domain=' + ops.domain : '',
                    secure = ops.secure ? '; secure' : '';
                document.cookie = [ckNa, '=', encodeURIComponent(ckVl), expires, path, domain, secure].join('');
                return ckVl;
            } catch (e) { }
        },
        getCookie: function (ckNa) {
            try {
                var arr = DCM.cookie ? DCM.cookie.match(new RegExp("(^| )" + REG(ckNa) + "=([^;]*)(;|$)")) : [];
                if (arr != null && arr != "null" && arr != "") { return decodeURIComponent(arr[2]); };
                return '';
            } catch (e) { }
        },
        delCookie: function (ckNa) {
            try {
                var exp = new Date(), cval = t.getCookie(ckNa);
                exp.setTime(exp.getTime() - 10000);
                DCM.cookie = ckNa + "=";
                DCM.cookie = ckNa + "=;path=/;expires=" + exp.toGMTString();
            } catch (e) { }
        },
        
        /**
         * 去除特殊字符
         * @param {string} str 
         */
        stripChar: function (str) {
            if (typeof (str) != "number" && typeof (str) != "string") { return str; };
            str = trim(str.toString());
            var repArr = [
                [/'/gi, /,/gi, /"/gi, /;/gi],
                ["", "，", "“", "；"]
            ];
            for (var i = 0; i < repArr[0].length; i++) {
                str = str.replace(repArr[0][i], (repArr[1][i] ? repArr[1][i] : ""));
            }
            return str;
        },
        
        /**
         * 请求数据处理
         * @param {string} str 待处理的字符串
         * @param {string} stp 类型，为keep不处理特殊字符
         */
        subData: function (str, stp) {
            if (typeof (str) != "number" && typeof (str) != "string") { return str; };
            if (stp != "keep") { str = t.stripChar(str); }
            return enCode(str);
        },
        
        /*
            返回的url字符串序列
            参数形式1: t.toURL(tObj[,arg1][,arg2]);
            tObj参数:tObj为字符串时，已经是URL序列则原样返回，否则是对象的ID值(arg1为self是取本对像(否则取子对象),arg2为keep表示保留数据库安全字符);
            tObj为常规对象时,键名和键值即是URL参数名和参数值;
            tObj为数组时,数组值为标签ID，ID值作为URL参数名称，ID值的对象值作为对应的URL参数的值;
        */
        toURL: function (tObj) {
            var fd = function (cid) {
                var cObj = typeof (cid) == "object" ? cid : ID(cid);
                return trim(cObj.name ? cObj.name : cObj.id);
            }, urlStr = "";
            if (typeof (tObj) == "string") {
                if (inTrim(tObj).match(/(\w+=.*?)+/gi)) { return trim(tObj).replace(/&$/gi, ''); }; /*排除原先已是url序列的字符串*/
                var Obj = ID(tObj), ctlObjs, ctlObj, rdArr, rdVl, cName = "";
                if (!Obj) { return "" };
                if (arguments[1] == "self") {
                    return fd(tObj) + "=" + t.subData(val(tObj), (arguments[2] ? arguments[2] : "keep"));
                } else {
                    /*获取当前对象子元素的URL字符串*/
                    var ctls = ["input", "select", "textarea", "iframe"];
                    for (var ci = 0; ci < ctls.length; ci++) {
                        ctlObjs = Obj.getElementsByTagName(ctls[ci]);
                        for (var ti = 0; ti < ctlObjs.length; ti++) {
                            ctlObj = ctlObjs[ti];
                            if (ctls[ci] == "input" && ctlObj.type == "radio") {
                                if (ctlObj.name) {
                                    if (ctlObj.name != cName) {
                                        cName = ctlObj.name;
                                        rdArr = Obj.getElementsByName(ctlObj.name);
                                        rdVl = rdArr[0].value;
                                        for (var ri = 0; ri < rdArr.length; ri++) {
                                            if (rdArr[ri].checked) {
                                                rdVl = rdArr[ri].value;
                                            }
                                        }
                                        urlStr += fd(ctlObj) + "=" + t.subData(val(ctlObj), (arguments[2] ? arguments[2] : "keep")) + "&";
                                    };
                                } else {
                                    urlStr += fd(ctlObj) + "=" + t.subData(val(ctlObj), (arguments[2] ? arguments[2] : "keep")) + "&";
                                }
                            } else if (ctls[ci] == "iframe") {
                                if (trim(ctlObj.getAttribute("role")).match(/^writable/gi)) {
                                    urlStr += fd(ctlObj) + "=" + t.subData(val(ctlObj), (arguments[2] ? arguments[2] : "keep")) + "&";
                                }
                            } else {
                                urlStr += fd(ctlObj) + "=" + t.subData(val(ctlObj), (arguments[2] ? arguments[2] : "keep")) + "&";
                            }
                        }
                    }
                }
            } else if (typeof (tObj) == "object") {
                if (isArray(tObj)) {
                    for (var ky = 0; ky < tObj.length; ky++) {
                        urlStr += tObj[ky] + "=" + t.subData(val(tObj[ky]), (arguments[1] ? arguments[1] : "keep")) + "&";
                    }
                } else {
                    for (var oKy in tObj) {
                        urlStr += oKy + "=" + t.subData(tObj[oKy], (arguments[1] ? arguments[1] : "keep")) + "&";
                    }
                }
            }
            return urlStr.replace(/&$/gi, '');
        },
        
        /**
         * 生成播放器代码
         * @param {string}} url 
         * @param {object} bPara 
         * @param {object} sPara 
         * @param {bool} isNew 
         */
        makeMedia: function (url, bPara, sPara, isNew) {
            /*
              作用:生成flash对象或返回flash的HTML代码
              参数:makeMedia(url,bPara,sPara)
                   url:flash文件的地址;
                   bPara:为对象,传递给flash的参数数组;
                   sPara:为对象,传递给flash内部的执行代码的参数对象;
                   isNew:是否强制更新flash对象,防止浏览器缓存flash对象
            */
            if (!trim(url)) { return false };
            var htmlStr, bPara = bPara ? bPara : {}, sPara = sPara ? sPara : {}, mType,
                url = (isNew ? aPara(url, "t=" + t.timeNum()) : url),
                sType = (!parseInt(bPara['width']) || !parseInt(bPara['height'])) ? 'hide' : 'show',
                ext = pathInfo(url)['ext'];
            if (ext == "swf") {
                mType = ' classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" ';
                bPara = objMerge({ "id": "_TempFlash" + t.timeNum(), "movie": url, "src": url, "width": "1px", "height": "1px", "flashvars": t.toURL(sPara), "allowscriptaccess": "always", "wmode": "transparent", "MENU": "false" }, bPara);
            } else if (findVl(ext, ["wma", "wav", "mp3", "midi", "mid", "asf", "wmv", "mpeg", "mpg", "avi", "aiff", "au"])) {
                mType = ' classid="CLSID:6BF52A52-394A-11d3-B153-00C04F79FAA6" ';
                bPara = objMerge({ "id": "_TempMediaPlayer" + t.timeNum(), "url": url, "src": url, "width": "1px", "height": "1px" }, bPara);
            }
            if (!ID(bPara['id'])) {

                /*生成代码*/
                htmlStr = '<object id="' + (A.jQuery.browser.msie ? bPara['id'] : bPara['id'] + "_ie") + '" name="' + (A.jQuery.browser.msie ? bPara['id'] : bPara['id'] + "_ie") + '"' + mType + ' style="width:' + parseInt(bPara['width']) + 'px;height:' + parseInt(bPara['height']) + 'px;">';
                for (var na in bPara) {
                    if (findVl(na.toLowerCase(), ["id", "width", "height", "src"])) { continue; }
                    htmlStr += '<param name="' + na + '" value="' + bPara[na] + '" />';
                }
                htmlStr += '<embed id="' + (A.jQuery.browser.msie ? bPara['id'] + "_ff" : bPara['id']) + '" name="' + (A.jQuery.browser.msie ? bPara['id'] + "_ff" : bPara['id']) + '"' + mType + ' style="width:' + parseInt(bPara['width']) + 'px;height:' + parseInt(bPara['height']) + 'px;" ';
                for (var na in bPara) {
                    if (findVl(na.toLowerCase(), ["id", "width", "height", "movie"])) { continue; }
                    htmlStr += na + '="' + bPara[na] + '" ';
                }
                htmlStr += '></embed>';
                htmlStr += '</object>';
                /*附件或返回代码*/
                if (sType == 'hide') {
                    val(cElem({ 'tag': 'div', 'attr': { 'style': 'position:absolute;left:-10px;height:1px;width:1px;overflow:hidden;' } }, DBD), htmlStr);
                    if (!A[bPara['id']]) { A[bPara['id']] = ID(bPara['id']); } /*修改浏览器下动态加载的object访问问题*/
                } else {
                    return htmlStr;
                }
            }
        },
        
        /**
         * 获取Dom对象的位置
         * @param {object} obj 
         */
        getPos: function (obj) {
            var sL = parseInt(DEM ? DEM.scrollLeft : DBD.scrollLeft),
                sT = parseInt(DEM ? DEM.scrollTop : DBD.scrollTop),
                x, y, obj = ID(obj), xy = new Object();
            oRect = obj.getBoundingClientRect();
            x = parseInt(oRect.left) + sL + "px";
            y = parseInt(oRect.top) + sT + "px";
            xy['x'] = x;
            xy['y'] = y;
            return xy;
        },
        
        /**
         * 获取当前鼠标位置
         */
        mousePos: function () {
            var evt = getEvent(),
                Dom = (DEM ? DEM : DBD),
                cx = evt.pageX ? evt.pageX : (evt.clientX ? (evt.clientX + (Dom.scrollLeft ? Dom.scrollLeft : document.body.scrollLeft)) : 0),
                cy = evt.pageY ? evt.pageY : (evt.clientY ? (evt.clientY + (Dom.scrollTop ? Dom.scrollTop : document.body.scrollTop)) : 0);
            return { 'x': cx, 'y': cy };
        },
        
        /**
         * 判断鼠标是否在指定的Dom对象区域
         * @param {string} tid Dom对象的ID
         */
        inArea: function (tid) {
            var obj = ID(tid), xy = t.getPos(obj), mXY = t.mousePos(),
                w = obj.offsetWidth, h = obj.offsetHeight;
            xy['x'] = parseInt(xy['x']);
            xy['y'] = parseInt(xy['y']);
            return (mXY['x'] >= xy['x'] && mXY['x'] <= xy['x'] + w) && (mXY['y'] >= xy['y'] && mXY['y'] <= xy['y'] + h);
        },
        
        /**
         * 节点对象的值长度校验
         * 
         * @param {Object|String} obj 节点对象或节点对象的ID
         * @param {String} tipsId 提示对象或提示对象ID
         * @param {Number} maxlen 最大长度
         */
        strlenVerify: function(obj, tipsId, maxlen){
            var v = val(obj), 
                maxlen = !maxlen ? 200 : maxlen, 
                curlen = maxlen, 
                len = strlen(v);
            for(var i = 0; i < v.length; i++) {
                if(v.charCodeAt(i) < 0 || v.charCodeAt(i) > 255) {
                    curlen -= 2;
                }
            }
            if(curlen >= len) {
                val(tipsId, curlen - len);
            } else {
                val(obj, mbCutStr(v, maxlen, true));
            }
        },
        
        /**
         * 按双字节统计字符串长度
         * @param {string} str 
         */
        sumMbChar: function(str){
            if (!str) { return 0; };
            var re = new RegExp("^[\\u4e00-\\u9fa5]$"), sNum = 0, dNum = 0;
            for (var ni = 0; ni < str.length; ni++) {
                if (!re.test(str.substr(ni, 1))) {
                    sNum++;
                } else {
                    dNum++;
                }
            }
            return dNum + (Math.ceil(sNum / 2));
        },
        
        /**
         * 给数字加入前导0,如5->005
         * 
         * @param {String} nStr 
         * @param {Number} len 
         */
        fillNum: function (nStr, len){
                var len=(len==undefined ? 3 : len),nStr=nStr.toString(),sNum=nStr.length;
            if(sNum >= len){return nStr;}
            for(var fi=0;fi< len-sNum;fi++){
                nStr="0"+nStr;
            }
            return nStr;
        },
        
        /**
         * 字符串长度
         * 
         * @param {String} str 
         */
        strlen: function (str) {
            return ($.browser.msie && str.indexOf('\n') != -1) ? 
                    str.replace(/\r?\n/g, '_').length : str.length;
        },

        /**
         * 获取鼠标选择项
         */
        getSelection: function (){
            return (A.getSelection ? A.getSelection(): (
                            DCM.getSelection ? DCM.getSelection(): (
                                DCM.selection ? DCM.selection.createRange().text : ""
                            )
                    ));
        },
        
        /**
         * 动态添加内联样式
         * 
         * @param {String} cssCode 样式字符串
         * @param {Object} obj 操作对象
         */
        addSheet: function (cssCode, obj) {
            var doc=obj||DCM;
            if (! +"\v1") {//增加自动转换透明度功能，用户只需输入W3C的透明样式，它会自动转换成IE的透明滤镜  
                var t = cssCode.match(/opacity:(\d?\.\d+);/);
                if (t != null) {
                    cssCode = cssCode.replace(t[0], "filter:alpha(opacity=" + parseFloat(t[1]) * 100 + ")")
                }
            }
            cssCode = cssCode + "\n"; //增加末尾的换行符，方便在firebug下的查看。  
            var headElement = doc.getElementsByTagName("head")[0];
            var styleElements = headElement.getElementsByTagName("style");
            if (styleElements.length == 0) {//如果不存在style元素则创建  
                if (doc.createStyleSheet) {    //ie  
                    doc.createStyleSheet();
                } else {
                    var tempStyleElement = doc.createElement('style'); //w3c  
                    tempStyleElement.setAttribute("type", "text/css");
                    headElement.appendChild(tempStyleElement);
                }
            }
            var styleElement = styleElements[0];
            var media = styleElement.getAttribute("media");
            if (media != null && !/screen/.test(media.toLowerCase())) {
                styleElement.setAttribute("media", "screen");
            }
            if (styleElement.styleSheet) {    //ie  
                styleElement.styleSheet.cssText += cssCode;
            } else if (doc.getBoxObjectFor) {
                styleElement.innerHTML += cssCode; //火狐支持直接innerHTML添加样式表字串  
            } else {
                styleElement.appendChild(doc.createTextNode(cssCode))
            }
        },
        
        /**
         * 加入收藏
         * 
         * @param {String} site 
         * @param {String} wname 
         */
        addFavorite: function(site, wname){
            if (DCM.all) {
                A.external.addFavorite(site, wname);
            } else if (A.sidebar) {
                A.sidebar.addPanel(wname, site, "");
            }
        },
        
        /**
         * 设为首页
         * 
         * @param {String} siteUrl 
         */
        setHomepage: function(siteUrl){
            if (DCM.all){
                DBD.style.behavior='url(#default#homepage)';
                DBD.setHomePage(siteUrl);
            }else if(A.sidebar){
                if(A.netscape){
                    try{
                        A.netscape.security.PrivilegeManager.enablePrivilege("UniversalXPConnect");
                    }catch(e){
                        alert("该操作被浏览器拒绝，假如想启用该功能，请在地址栏内输入 about:config,然后将项 signed.applets.codebase_principal_support 值该为true");
                    }
                }
                var prefs=A.Components.classes['@mozilla.org/preferences-service;1'].getService(A.Components.interfaces.nsIPrefBranch);
                prefs.setCharPref('browser.startup.homepage',siteUrl);
            }
        },
        
        /**
         * 图片轮播
         * 
         * 用法示例:
         * var carouselObj=new Carousel();
         * carouselObj.start(
         *      ['#reco_box1'],
         *      {pre:"#recoUpBt", next:"#recoNextBt", handle: "#goTo a"},
         *      {auto: true, second: 1, fstep: 20, direc: 'left'},
         *      function(rNum){
         *          alert('success');
         *      }
         *  );
         * 参数说明:
         * start(auto, oBoxs, oHandle, settings, callBack)
         * 
         * oBoxs: 外部容器
         * oHandle: 控制容器
         *   pre: 向前移动
         *   next: 向后移动
         *   handle: 多个移动对象的操作
         * settings: 动画设置
         *   auto: 是否自动播放
         *   second: 动画完成时间(秒)
         *   fstep: 动画的速度,即是完成动画需要的步数
         *   direc: 自动播放的方向
         * callBack 动画执行完成后的回调函数，传递的参数为
         */
        Carousel: function () {
            function swing(p) {/*加速效果函数*/
                return (-Math.cos(p * Math.PI) / 2) + 0.5;
            }
            function filter(str) {
                return str.replace(/[^\w_]+/gi, "");
            }
            this.start = function (oBoxs, oHandle, settings, callBack) {
                var settings=settings||{},
                    auto = typeof (settings['auto']) != 'undefined' ? settings['auto'] : false,
                    second = typeof (settings['second']) != 'undefined' ? settings['second'] : 1,
                    fstep = typeof (settings['fstep']) != 'undefined' ? settings['fstep'] : 20,
                    direc = typeof (settings['direc']) != 'undefined' ? settings['direc'] : 'left',
                    fn = typeof (callBack) != 'function' ? function () { } : callBack,
                    boxWidth = 0, innerWidth = 0, itemWidth = 0, ratios = [], 
                    num = 0, rNum = 0, speed = (second / fstep) * 1000,
                    step = fstep, timerId, autotimerId, itemNum,
                    toLeft, toRight, run;

                boxWidth = $(oBoxs[0]).width();
                innerWidth = $(oBoxs[0] + " > :first-child").width();
                itemNum = $(oBoxs[0] + " > :first-child").children().length;
                itemWidth = innerWidth / itemNum;

                if (boxWidth >= innerWidth) {
                    return false;
                }

                for (var i = 0; i < oBoxs.length; i++) {
                    $(oBoxs[i] + " > :first-child").width($(oBoxs[i] + " > :first-child").width() * 2);
                    $(oBoxs[i] + " > :first-child").append($(oBoxs[i] + " > :first-child").html());
                    ratios[i] = $(oBoxs[i]).width() / $(oBoxs[0]).width();
                }
                innerWidth *= 2;

                run = function (s, bm) {
                    return function () {
                        if (s == 1) {/*向左滑动*/
                            num++;
                            if (num > step) {
                                num = 0;
                                clearInterval(timerId);
                                rNum += bm;
                                if (rNum >= (innerWidth / itemWidth / 2)) {/*当滑动等于半宽时设置为0*/
                                    for (var i = 0; i < oBoxs.length; i++) {
                                        $(oBoxs[i])[0].scrollLeft = 0;
                                    }
                                    rNum = 0;
                                }
                                if (oHandle['handle']) {
                                    try {
                                        $(oHandle['handle'] + " a").attr("class", filter(oHandle['handle']) + "_out");
                                        $(oHandle['handle'] + " a:eq(" + rNum + ")").attr("class", filter(oHandle['handle']) + "_over");
                                    } catch (e) { }
                                }
                                (fn)(rNum);
                            } else {
                                for (var i = 0; i < oBoxs.length; i++) {
                                    var rw = (swing(num / step) * itemWidth + rNum * itemWidth) * ratios[i] * bm;
                                    $(oBoxs[i])[0].scrollLeft = rw;
                                }
                            }
                        } else {/*向右滑动*/
                            if (!rNum && !num) {/*当为0时设置半宽*/
                                rNum = innerWidth / itemWidth / 2;
                            }
                            num++;
                            if (num > step) {
                                num = 0;
                                clearInterval(timerId);
                                rNum -= bm;
                                if (oHandle['handle']) {
                                    $(oHandle['handle'] + " a").attr("class", filter(oHandle['handle']) + "_out");
                                    $(oHandle['handle'] + " a:eq(" + rNum + ")").attr("class", filter(oHandle['handle']) + "_over");
                                }
                                (fn)(rNum);
                            } else {
                                for (var i = 0; i < oBoxs.length; i++) {
                                    var rw = (rNum * itemWidth - swing(num / step) * itemWidth * bm) * ratios[i];
                                    $(oBoxs[i])[0].scrollLeft = rw;
                                }
                            }
                        }
                    }
                }

                toLeft = function (bm) {
                    clearInterval(timerId);
                    timerId = setInterval(run(1, (typeof (bm) == "number" && bm > 0 ? bm : 1)), speed);
                }
                toRight = function (bm) {
                    clearInterval(timerId);
                    timerId = setInterval(run(-1, (typeof (bm) == "number" && bm > 0 ? bm : 1)), speed);
                }

                if (auto) {
                    autotimerId = setInterval((direc == 'left' ? toLeft : toRight), (second + 5) * 1000);
                }
                if (oHandle['pre']) {
                    $(oHandle['pre']).click(function () {
                        clearInterval(autotimerId);
                        toLeft();
                    });
                }
                if (oHandle['next']) {
                    $(oHandle['next']).click(function () {
                        clearInterval(autotimerId);
                        toRight();
                    }); 
                }
                if (oHandle['handle']) {
                    $(oHandle['handle']).click(function () {
                        clearInterval(autotimerId);
                        var cdx = $(oHandle['handle']).parent().index(this);
                        if (cdx < rNum) {
                            toRight(rNum - cdx);
                        } else if (cdx > rNum) {
                            toLeft(cdx - rNum);
                        }
                    });
                }
            }
        },
        CarouselSimple: function () {
            function swing(p) {/*加速效果函数*/
                return (-Math.cos(p * Math.PI) / 2) + 0.5;
            }
            this.start = function (box, oHandle, settings, callBack) {
                var settings=settings||{},
                    duration = typeof (settings['duration']) != 'undefined' ? settings['duration'] : 1,
                    framesPerItem = typeof (settings['frames']) != 'undefined' ? settings['frames'] : 20,
                    fn = typeof (callBack) != 'function' ? function () { } : callBack,
                    speed = (duration / framesPerItem) * 1000,
                    timerId, autotimerId;
                
                // 外部容器对象
                var container=$(box);
                // 内部容器对象
                var innerContainer=container.find("> :first-child");
                
                // 外部容器宽度
                var boxWidth = container.width();
                // 滚动组件总宽度
                var innerWidth = innerContainer.width();
                // 项目总数量
                var totalItems = innerContainer.children().length;
                // 单个滚动条目宽度
                var itemWidth = innerWidth / totalItems;
                // 可滚动条目数量
                var scollItems= totalItems-Math.floor(boxWidth/itemWidth);
                // 当前滚动条目索引
                var scrollIndex = 0;
                
                // 当前滚动帧
                var frameIndex = 0;
                
                
                
                // 如果外部容器宽度小于滚动组件总宽度，不执行操作
                if (boxWidth >= innerWidth || !scollItems) {
                    return false;
                }

                var run = function (direction) {
                    return function () {
                        //向左滑动
                        if (direction >0) {
                            if(scrollIndex){
                                frameIndex++;
                                if (frameIndex > framesPerItem) {
                                    frameIndex = 0;
                                    clearInterval(timerId);
                                    scrollIndex--;
                                    (fn)(scrollIndex);
                                } else {
                                    var rw = (scrollIndex-swing(frameIndex / framesPerItem)) * itemWidth;
                                    container[0].scrollLeft = rw;
                                }
                            }
                            return;
                        }
                        
                        // 向右滑动
                        if(scrollIndex< scollItems){
                            frameIndex++;
                            if (frameIndex > framesPerItem) {
                                frameIndex = 0;
                                scrollIndex++;
                                clearInterval(timerId);
                                (fn)(scrollIndex);
                            } else {
                                var rw = (scrollIndex + swing(frameIndex / framesPerItem)) * itemWidth;
                                container[0].scrollLeft = rw;
                            }
                        }
                        
                    }
                }

                var toLeft = function () {
                    clearInterval(timerId);
                    timerId = setInterval(run(1), speed);
                }
                var toRight = function () {
                    clearInterval(timerId);
                    timerId = setInterval(run(-1), speed);
                }

                if (oHandle['pre']) {
                    $(oHandle['pre']).click(function () {
                        clearInterval(autotimerId);
                        toLeft();
                    });
                }
                if (oHandle['next']) {
                    $(oHandle['next']).click(function () {
                        clearInterval(autotimerId);
                        toRight();
                    });
                }
            }
        },
        
        /**
         * URL参数反序列号
         * 
         * @param {String} str 已经序列化的字符串
         * @returns Array
         */
        unserialize: function (str){
            var result={},
                vars=str.split("&");
            for(var i=0; i< vars.length; i++){
                var kv=vars[i].split("="),
                    key=decodeURIComponent(kv[0]),
                    val=decodeURIComponent(kv[1]),
                    index=key.indexOf('[');

                if(index!=-1){
                    var res=key.substr(index).match(/\[[^\]]*?\]/g);
                    key=key.substr(0, index);
                    if(res){
                        var tmp=result,
                            isObject=true;
                        for(var n=0; n< res.length; n++){
                            var k=res[n].substr(1, res[n].length-2);
                            isObject=k!=='';

                            if(typeof(tmp[key])=='undefined'){
                                tmp[key]=isObject ? {} : [];
                            }

                            tmp=tmp[key];
                            key=k;
                        }
                        if(isObject){
                            tmp[key]=val;
                        }else{
                            tmp.push(val);
                        }
                    }
                }else{
                    result[key]=val;
                }
            }
            return result;
        }
        
    });
    
    // 初始化
    init();
    A[myTool] = t;
    
    // 模块集成
    if (typeof define === "function" && define.cmd) {
        define(myTool, [], function(){
            return t;
        });
    }
})(window);